<template>
  <v-container
    :style="'padding: 0; margin: 0;width: 100%;'"
    fill-height
    fluid
    wrap
  >
    <v-layout
      row
      wrap>

      <v-card
        :style="'padding: 0; margin: 0;width: 100%;'"
        flat>
        <v-tabs v-model="tab">
          <v-tab>{{ strings[idioma].usuarios }}</v-tab>
          <v-tab>{{ strings[idioma].empresas }}</v-tab>
          <v-tab>{{ strings[idioma].alimentos }}</v-tab>
        </v-tabs>
        <v-flex md12>

          <material-card
            v-if="users && tabsEnum[tab] === 'usuarios'"
            color="primary"
            text=""
            xs12
          >
            <template>
              <v-btn
                :flat="!filtrarPremiumTeste"
                color="primary"
                small
                @click="pagina = 1; filtrarPremiumTeste = !filtrarPremiumTeste; recarregaUsers();">
                Premium Teste
              </v-btn>
              <v-btn
                :flat="!filtrarPremium"
                color="primary"
                small
                @click="pagina = 1; filtrarPremium = !filtrarPremium; recarregaUsers();">
                Premium
              </v-btn>
              <v-btn
                :flat="!filtrarPremiumVencido"
                color="primary"
                small
                @click="pagina = 1; filtrarPremiumVencido = !filtrarPremiumVencido; recarregaUsers();">
                Premium Vencido
              </v-btn>
              <v-btn
                :flat="!filtrarPlanoVencendo"
                color="primary"
                small
                @click="pagina = 1; filtrarPlanoVencendo = !filtrarPlanoVencendo; recarregaUsers();">
                Premium Vencendo
              </v-btn>
              <v-btn
                :flat="!filtrarConsultoria"
                color="primary"
                small
                @click="pagina = 1; filtrarConsultoria = !filtrarConsultoria; recarregaUsers();">
                Consultor
              </v-btn>
              <v-btn
                :flat="!filtrarPecuarista"
                color="primary"
                small
                @click="pagina = 1; filtrarPecuarista = !filtrarPecuarista; recarregaUsers();">
                Pecuarista
              </v-btn>
              <v-btn
                :flat="!filtrarVinculados"
                color="primary"
                small
                @click="pagina = 1; filtrarVinculados = !filtrarVinculados; recarregaUsers();">
                Vinculados
              </v-btn>
              <v-btn
                :flat="!filtrarAdmin"
                color="primary"
                small
                @click="pagina = 1; filtrarAdmin = !filtrarAdmin; recarregaUsers();">
                Adm
              </v-btn>
              <v-btn
                :flat="!filtrarInativos"
                color="primary"
                small
                @click="pagina = 1; filtrarInativos = !filtrarInativos; recarregaUsers();">
                Inativos
              </v-btn>
            </template>
            <v-sheet class="pa-3 primary">
              <v-layout
                row
                wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="searchUsers"
                    :label="strings[idioma].usuarios"
                    dark
                    flat
                    solo-inverted
                    hide-details
                    clearable
                    append-icon="mdi-magnify"
                    clear-icon="mdi-close"
                    @keydown="pagina = 1"
                    @click="pagina = 1"
                    @change="pagina = 1"
                  />
                </v-flex>
              </v-layout>
            </v-sheet>
            <div
              class="blue mx-auto py-2 white--text pr-2 pl-2"
              style="width: 100%">Foram encontrados {{ countResultados }} usuários</div>
            <div style="max-height: 300px; overflow:auto;">
              <v-card v-if="loadingUsers">
                <v-layout
                  
                  :style="{'height': heightCard}"
                  column
                  fill-height
                  justify-center
                  align-center
                >
                  <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  >
                  </v-progress-circular>
                </v-layout>
              </v-card>
              <v-card
                v-else
                class="mx-auto"
                style="width: 100%"
                tile
              >
                <v-list
                  v-if="users"
                  dense
                  ripple
                  flat
                  rounded>
                  <div color="primary">
                    <v-list-tile
                      v-for="us in users"
                      :key="us.id"
                      :style="us.EXCLUIDO === 1 ? 'opacity: 0.6;': null"
                      flat
                      @click="excluir ? removeUser(us) : vincular ? vincularColaborador(us) : (premium || tempo_premium) ? touglePremium(us) : (consultoria || tempo_consultor) ? tougleConsultor(us) : editUser(us)">

                      <v-list-tile-avatar>
                        <v-icon
                          v-if="us.plano && us.plano.revogado === 1"
                          :color="'orange'"
                          title="Plano revogado"
                          v-text="'mdi-account-alert'"
                        />
                        <v-icon
                          v-else-if="us.EXCLUIDO !== 1"
                          :color="(us.permissao === 0) ? 'red': (us.lido === 0) ? 'green' : 'black'"
                          v-text="'mdi-account'"
                        />
                        <v-icon
                          v-else
                          :color="(us.permissao === 0) ? 'red': ''"
                          v-text="'mdi-account-off'"
                        />
                        <v-icon
                          v-if="us.liberado === 0"
                          :color="'black'"
                          v-text="'mdi-lock'"
                        />
                        <!-- aguardando pagamento -->
                        <v-icon
                          v-else-if="us.plano && us.plano.status === -1"
                          :color="'red'"
                          title="Aguardando Pagamento"
                          v-text="'mdi-timer'"/>
                        <!-- aguardando verificação de e-mail -->
                        <v-icon
                          v-else-if="us.permissao === 2"
                          :color="'orange'"
                          title="Aguardando Verificação de E-mail"
                          v-text="'mdi-email-alert'"/>
                      </v-list-tile-avatar>
                      <v-list-tile-action>
                        <span :style="(us.lido === 0) ? 'color: green' : 'color: black'"><v-icon v-if="(us.plano && (us.plano.data_final === null || moment().diff(us.plano.data_final, 'days') <= 0)) || (us.plano === null && us.premium === 1)">mdi-star</v-icon>{{ us.id }}</span>
                      </v-list-tile-action>
                      <v-list-tile-content style="width: 40%">
                        <v-list-tile-title
                          :style="(us.lido === 0) ? 'color: green' : 'color: black'"
                          class = "text-uppercase"
                        >
                          {{ us.NOME }}
                          <small v-if="us.plano">
                            - {{ strings[idioma].tempo_de_plano }} ({{ (us.plano.data_inicio) ? moment(us.plano.data_inicio).format(strings[idioma].formato_datas_sem_hora) : '∞' }}, {{ (us.plano.data_final) ? moment(us.plano.data_final).format(strings[idioma].formato_datas_sem_hora) : '∞' }})
                            <span v-if="us.plano.valor !== null">- Valor pago: $ {{ us.plano.valor.toFixed(2).replace('.', strings[idioma].separador_float) }}
                            </span>
                          </small>
                        </v-list-tile-title>
                        <v-list-tile-sub-title :style="(us.lido === 0) ? 'color: green' : 'color: black'">{{ us.email }} <small v-if="us.consultoria && !us.consultoria.EXCLUIDO">- Tempo de Consultor  ({{ (us.consultoria.data_inicio) ? moment(us.consultoria.data_inicio).format(strings[idioma].formato_datas_sem_hora) : '∞' }}, {{ (us.consultoria.data_fim) ? moment(us.consultoria.data_fim).format(strings[idioma].formato_datas_sem_hora) : '∞' }})</small>
                          <template v-if="gerenciaPremium">
                            -
                            <a
                              flat
                              color="error"
                              small
                              @click="premium = true; tempo_premium = true; userPivot = us">{{ strings[idioma].definir_tempo_premium }}</a>
                          </template>
                          <template v-else-if="gerenciaConsultor">
                            -
                            <a
                              flat
                              color="error"
                              small
                              @click="consultor = true; tempo_consultor = true; userPivot = us">Definir o tempo de consultor</a>
                          </template>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <div
                          v-if="gerenciaPremium">

                          <template v-if="us.premium === 1">
                            <v-btn
                              flat
                              color="error"
                              @click="premium = true">{{ strings[idioma].revogar_premium }}</v-btn>
                          </template>
                        </div>
                        <div
                          v-else-if="gerenciaConsultor">

                          <template v-if="us.consultoria && !us.consultoria.EXCLUIDO">
                            <v-btn
                              flat
                              color="error"
                              @click="consultoria = true">Revogar Consultoria</v-btn>
                          </template>
                        </div>
                        <div v-else-if="modoSuperUsuario">
                          <v-btn
                            :color="'red'"
                            flat
                            @click="excluir = true"><v-icon>mdi-close</v-icon></v-btn>
                        </div>
                        <div v-else>
                          <v-btn
                            v-if="us.emp_user === null"
                            :color="(us.permissao === 0) ? 'red': (us.lido === 0) ? 'green' : 'black'"
                            flat
                            @click="vincular = true">{{ strings[idioma].vincular }}</v-btn>
                          <span v-else><a @click="vincular = true">{{ strings[idioma].vinculado_a.format(us.empresa_vinculada[0].nome) }} </a></span>
                        </div>
                      </v-list-tile-action>
                    </v-list-tile>
                  </div>
                </v-list>

              </v-card>
            </div>
            <template>
              <div
                class="text-xs-center">
                <v-layout
                  align-start
                  justify-space-around
                  wrap
                  justify-center
                  center>
                  <v-flex md12>
                    <v-pagination
                      v-model="pagina"
                      :length="paginaTotal"
                      :total-visible="limit"
                      circle/>
                  </v-flex>

                </v-layout>
              </div>
            </template>
            <div v-if="!gerenciaPremium && !gerenciaConsultor">
              <v-btn
                small
                flat
                href="/adm/user/new">
                <v-icon>mdi-plus</v-icon>
                &nbsp;
                {{ strings[idioma].add_novo_usuario }}
              </v-btn>
              <v-btn
                small
                flat
                @click="gerenciaPremium = true">
                <v-icon>mdi-star</v-icon>
                &nbsp;
                {{ strings[idioma].gerenciar_premium }}
              </v-btn>
              <v-btn
                small
                flat
                color="error"
                @click="modoSuperUsuario = !modoSuperUsuario">
                <v-icon>mdi-account</v-icon>
                &nbsp;
                {{ !modoSuperUsuario ? 'Ativar Super Usuário' : 'Desativar Super Usuário' }}
              </v-btn>
              <v-btn flat @click="exportaUsers">
                {{ strings[idioma].exporta_csv }}
              </v-btn>
            </div>
            <div v-else>
              <v-btn
                small
                flat
                @click="gerenciaPremium = gerenciaConsultor = false">
                <v-icon>mdi-back</v-icon>
                &nbsp;
                {{ strings[idioma].voltar }}
              </v-btn>
            </div>
            <a href="/adm/solicitacaoPremium">Solicitações de premium</a>
            <v-container grid-list-12 fluid>
              <v-layout row wrap>
                <v-flex>
                  <v-btn small @click="gerarUsuariosProximosAVencer()">Ver os Usuários Proxímos a Vencer</v-btn>
                </v-flex>
                <v-flex>
                  <v-btn small @click="gerarComumMaisUsam()">Ver os Usuários Comuns que Mais Usam</v-btn>
                </v-flex>
                <v-flex>
                  <v-btn small @click="gerarComumMenosUsam()">Ver os Usuários Comuns que Menos Usam</v-btn>
                </v-flex>
                <v-flex>
                  <v-btn small @click="gerarPremiumMaisUsam()">Ver os Usuários Premium que Mais Usam</v-btn>
                </v-flex>
                <v-flex>
                  <v-btn small @click="gerarPremiumMenosUsam()">Ver os Usuários Premium que Menos Usam</v-btn>
                </v-flex>
                <v-flex>
                  <v-btn small @click="gerarVencidos()">Ver os Usuários Premium Vencidos</v-btn>
                </v-flex>
                <!--
                <v-flex>
                  <v-btn small @click="gerarFaturasRenovacao()">Gerar Faturas p/ Renovação</v-btn>
                </v-flex>
                <v-flex>
                  <v-btn small @click="gerarPromocao10Renovacao()">Gerar Promoção 10% Renovação</v-btn>
                </v-flex>
                -->
                <v-flex>
                  <v-spacer/>
                </v-flex>
              </v-layout>
            </v-container>
          </material-card>

        </v-flex>
        <v-flex md12>
          <material-card
            v-if="empresas && tabsEnum[tab] === 'empresas'"
            color="secundary"
            text=""
            xs12
          >
            <v-sheet class="pa-3 black">
              <v-layout
                row
                wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="searchEmpresas"
                    :label="strings[idioma].empresas"
                    dark
                    flat
                    solo-inverted
                    hide-details
                    clearable
                    append-icon="mdi-magnify"
                    clear-icon="mdi-close"
                  />
                </v-flex>
              </v-layout>
            </v-sheet>
            <div style="max-height: 300px; overflow:auto;">
              <v-list
                dense
                flat
                rounded>
                <v-list-tile
                  v-for="us in empresasFilter"
                  :key="us.id"
                  :style="us.EXCLUIDO === 1 ? 'opacity: 0.6;': null"
                  flat
                  @click="excluir === true ? removeEmpresa(us) : editEmpresa(us)">

                  <v-list-tile-avatar>
                    <v-icon
                      v-if="us.EXCLUIDO !== 1"
                      :color="(us.permissao === 0) ? 'red': ''"
                      v-text="'mdi-domain'"
                    />
                    <v-icon
                      v-else
                      :color="(us.permissao === 0) ? 'red': ''"
                      v-text="'mdi-domain-off'"
                    />
                  </v-list-tile-avatar>
                  <v-list-tile-action>
                    <span>{{ us.id }}</span>
                  </v-list-tile-action>
                  <v-list-tile-content style="width: 70%">
                    <v-list-tile-title

                      class = "text-uppercase"
                    > {{ us.nome_fantasia }}({{ us.nome }}) </v-list-tile-title>
                    <v-list-tile-sub-title>{{ $formatCnpjCpf(String(us.cnpj)) }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <div v-if="modoSuperUsuario">
                      <v-btn
                        :color="'red'"
                        flat
                        @click="excluir = true"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </div>
            <div>
              <v-btn
                small
                flat
                href="/adm/empresa/new">
                <v-icon>mdi-plus</v-icon>
                &nbsp;
                {{ strings[idioma].add_nova_empresa }}
              </v-btn>
              <v-btn
                small
                flat
                color="error"
                @click="modoSuperUsuario = !modoSuperUsuario">
                <v-icon>mdi-account</v-icon>
                &nbsp;
                {{ !modoSuperUsuario ? 'Ativar Super Usuário' : 'Desativar Super Usuário' }}
              </v-btn>
            </div>
          </material-card>
        </v-flex>
        <v-flex md12>
          <material-card
            v-if="alimentosFilter && tabsEnum[tab] === 'alimentos'"
            color="orange"
            text=""
            xs12
          >
            <v-sheet class="pa-3 orange">
              <v-layout
                row
                wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="searchAlimentos"
                    :label="strings[idioma].alimentos"
                    dark
                    flat
                    solo-inverted
                    hide-details
                    clearable
                    append-icon="mdi-magnify"
                    clear-icon="mdi-close"
                  />
                </v-flex>
              </v-layout>
            </v-sheet>
            <div style="max-height: 300px; overflow:auto;">
              <template v-if="false">
                <v-list
                  dense
                  flat
                  subheader
                  rounded>
                  <v-list-tile
                    v-for="us in alimentosFilter"
                    :key="us.id"
                    :style="us.EXCLUIDO === 1 ? 'opacity: 0.6;': null"
                    three-line
                    flat
                    href="javascript:void(0);"
                    @click="(excluir) ? removeAlimento(us) : (aprovarPatrocinio) ? patrocinar(us, 1) : (reprovarPatrocinio) ? patrocinar(us, 0) : verAlimento(us)">

                    <v-divider/>
                    <v-list-tile-content
                      flat
                      style="max-width: 90%;">

                      <v-list-tile-title

                        class = "text-uppercase"
                      >

                        <v-icon
                          v-if="us.EXCLUIDO !== 1"
                          :color="(us.permissao === 0) ? 'red': ''"
                          v-text="'mdi-nutrition'"
                      />#{{ us.id }} - {{ (us.empresa && us.empresa.nome) ? us.empresa.nome + ' - ' : '' }}{{ (idioma === 0) ? us.nome : ((us.nome_ingles !== '' && us.nome_ingles !== null) ? us.nome_ingles : us.nome) }} </v-list-tile-title>
                      <v-list-tile-sub-title>{{ categorias_alimentos.filter(c=>c.id === us.id_tipo)[0] ? categorias_alimentos.filter(c=>c.id === us.id_tipo)[0][(idioma === 0) ? 'name' : 'name_en'] : '' }} <v-btn
                        v-if="us.patrocinado === 1"
                        flat
                        color="success"
                        small
                        disabled> {{ strings[idioma].patrocinado }} </v-btn></v-list-tile-sub-title>
                      <v-list-tile-sub-title>

                        <v-btn
                          v-if="us.patrocinado === -1"
                          flat
                          color="success"
                          small
                          @click="aprovarPatrocinio = true"> <v-icon
                            small
                            v-text="'mdi-star'"
                        /> {{ strings[idioma].aceitar_patrocinio }} </v-btn>
                        <v-btn
                          v-if="us.patrocinado === -1"
                          flat
                          color="error"
                          small
                          @click="reprovarPatrocinio = true"> <v-icon
                            small
                            v-text="'mdi-star'"
                        /> {{ strings[idioma].rejeitar_patrocinio }} </v-btn>
                        <v-btn
                          v-else-if="us.patrocinado === 1"
                          flat
                          color="error"
                          small
                          @click="reprovarPatrocinio = true"> <v-icon
                            small
                            v-text="'mdi-star'"
                        /> {{ strings[idioma].revogar_patrocinio }} </v-btn>
                      </v-list-tile-sub-title>
                      <v-list-tile-action>
                        <v-btn
                          v-if="us.EXCLUIDO !== 1 && modoSuperUsuario"
                          :color="'red'"
                          flat
                          @click="excluir = true"><v-icon>mdi-close</v-icon></v-btn>
                      </v-list-tile-action>

                    </v-list-tile-content>

                  </v-list-tile>
                </v-list>
              </template>
              <v-list two-line>
                <template
                  v-for="alimento in alimentosFilter">

                  <v-list-tile
                    :key="alimento.id"
                    @click="(excluir) ? removeAlimento(alimento) : (aprovarPatrocinio) ? patrocinar(alimento, 1) : (reprovarPatrocinio) ? patrocinar(alimento, 0) : verAlimento(alimento)"

                  >
                    <v-list-tile-avatar>
                      <v-icon>mdi-corn</v-icon>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-subheader :key="alimento.id">{{ alimento.nome }}</v-subheader>
                      <v-list-tile-sub-title>{{ categorias_alimentos.filter(c=>c.id === alimento.id_tipo)[0] ? categorias_alimentos.filter(c=>c.id === alimento.id_tipo)[0][(idioma === 0) ? 'name' : 'name_en'] : '' }}
                        <v-btn
                          v-if="alimento.patrocinado === 1"
                          flat
                          color="success"
                          small
                          disabled>
                          {{ strings[idioma].patrocinado }}
                        </v-btn>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn
                        v-if="alimento.EXCLUIDO !== 1 && modoSuperUsuario"
                        :color="'red'"
                        flat
                        @click="excluir = true"><v-icon>mdi-close</v-icon></v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                  <div :key="alimento.id + '_option'">
                    <v-btn
                      v-if="alimento.patrocinado === -1"
                      flat
                      color="success"
                      small
                      @click="patrocinar(alimento, 1)"> <v-icon
                        small
                        v-text="'mdi-star'"
                    /> {{ strings[idioma].aceitar_patrocinio }} </v-btn>
                    <v-btn
                      v-if="alimento.patrocinado === -1"
                      flat
                      color="error"
                      small
                      @click="patrocinar(alimento, 0)"> <v-icon
                        small
                        v-text="'mdi-star'"
                    /> {{ strings[idioma].rejeitar_patrocinio }} </v-btn>
                    <v-btn
                      v-else-if="alimento.patrocinado === 1"
                      flat
                      color="error"
                      small
                      @click="patrocinar(alimento, 0)"> <v-icon
                        small
                        v-text="'mdi-star'"
                    /> {{ strings[idioma].revogar_patrocinio }} </v-btn>
                  </div>

                  <v-divider :key="alimento.id + '_div'"/>

                </template>
              </v-list>
            </div>
            <div>
              <v-btn
                small
                flat
                color="error"
                @click="modoSuperUsuario = !modoSuperUsuario">
                <v-icon>mdi-account</v-icon>
                &nbsp;
                {{ !modoSuperUsuario ? 'Ativar Super Usuário' : 'Desativar Super Usuário' }}
              </v-btn>
            </div>
          </material-card>
        </v-flex>
        
        <v-flex md12>
          <v-dialog
            v-model="dialogNutrientes"
            :fullscreen="$vuetify.breakpoint.xs"
            transition="dialog-bottom-transition"
          >
            <v-card v-if="dialogNutrientes">
              <v-card-title>
                <v-layout column>
                  <span class="headline">{{ alimento.nome }}</span>
                  <span>Empresa: {{ (alimento.empresa !== null) ? '#'+ alimento.empresa.id + ' ' + alimento.empresa.nome : '-' }} // Usuário: #{{ alimento.usuario.id }} {{ alimento.usuario.NOME }} ({{ alimento.usuario.email }})({{ alimento.usuario.cpf }})</span>
                </v-layout>
              </v-card-title>
              <v-card
                :height="calculandoNutrientes ? heightDialog : undefined"
                :max-height="heightDialog"
                style="overflow:auto"
              >

                <v-list v-if="!calculandoNutrientes">
                  <template
                    v-for="(ingrediente, index) in ingredientes"
                  >
                    <v-list-tile
                      :key="ingrediente.id"
                      class="list-restricoes">
                      <v-list-tile-content>
                        <v-layout
                          align-center
                          justify-space-around
                          row
                          py-2
                          style="width: 100%"
                        >
                          <v-flex
                            xs7
                            sm8
                            md9>
                            <span style="font-weight: 500;"> {{ !idioma ? ingrediente.exigencia : ingrediente.exigencia_en }} </span>
                          </v-flex>
                          <v-flex
                            xs5
                            sm4
                            md3>
                            <v-text-field
                              v-money="optionsNumber.float2[idioma]"
                              v-if = "parseString(alimento.nutrientes[ingrediente.id], idioma) !== 0"
                              :suffix="'(' + (!idioma ? ingrediente.unidade : ingrediente.unidade_en) + ')'"
                              v-model.lazy="alimento.nutrientes[ingrediente.id]"
                              outline
                              readonly
                              class="centered-input text-field-table text-field-nutrientes"
                              color="primary"
                              single-line
                            />
                            <v-text-field
                              v-else
                              outline
                              value="-"
                              class="centered-input text-field-table text-field-nutrientes"
                              readonly
                              color="primary"
                            />
                          </v-flex>
                        </v-layout>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider
                      v-if="index !== 'Zn'"
                      :key="index + '_divider'"
                    />
                  </template>
                </v-list>
                <v-layout
                  v-else
                  fill-height
                  align-center
                  justify-center
                  column
                >
                  <span style="font-weight: 500; padding: 4px">{{ strings[idioma].recalculando_nutrientes }}</span>
                  <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  />
                </v-layout>
              </v-card>
              <v-card-actions>
                <v-spacer/>
                <v-btn
                  :disabled="calculandoNutrientes"
                  color="error"
                  @click="dialogNutrientes = false"
                >
                  <v-icon
                    left
                    dark>mdi-close</v-icon>
                  {{ strings[idioma].fechar }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogPremium"

            persistent
            transition="dialog-bottom-transition"
            width="650"
            height="300"
          >
            <v-card style="min-height: 100px;">
              <v-layout
                v-if="loading"
                fill-height
                align-center
                justify-center
                column
                style="padding: 20px;"
              >
                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                />
              </v-layout>
              <template v-else-if="dialogPremium && userPivot && userPivot !== null">
                <v-card-title>
                  <v-layout column>
                    <span class="headline">{{ String(strings[idioma].definir_tempo_premium_para).format(userPivot.NOME) }} - {{ (userPivot.plano) ? moment(userPivot.plano.data_inicio).format(strings[idioma].formato_datas_sem_hora) : '' }}</span>
                    <span v-if="userPivot.plano"> {{ moment(userPivot.plano.data_final).format(strings[idioma].formato_datas_sem_hora) }} </span>
                    <v-card-actions>
                      <v-btn @click="dataFim = moment((dataFim && dataFim !== null) ? dataFim : moment().format('YYYY-MM-DD')).add(15, 'd').format('YYYY-MM-DD')">{{ (strings[idioma].mais_x_dias).format(15) }}</v-btn>

                      <v-btn @click="dataFim = moment((dataFim && dataFim !== null) ? dataFim : moment().format('YYYY-MM-DD')).add(1, 'M').format('YYYY-MM-DD')">{{ (strings[idioma].mais_x_meses).format(1) }}</v-btn>

                      <v-btn @click="dataFim = moment((dataFim && dataFim !== null) ? dataFim : moment().format('YYYY-MM-DD')).add(6, 'M').format('YYYY-MM-DD')">{{ (strings[idioma].mais_x_meses).format(6) }}</v-btn>

                      <v-btn @click="dataFim = moment((dataFim && dataFim !== null) ? dataFim : moment().format('YYYY-MM-DD')).add(1, 'y').format('YYYY-MM-DD')">{{ (strings[idioma].mais_x_meses).format(12) }}</v-btn>

                      <v-btn @click="salvarPremium(userPivot, null)">{{ (strings[idioma].mais_infinito) }}</v-btn>
                    </v-card-actions>

                  </v-layout>
                </v-card-title>
                <v-card>
                  <v-list>
                    <v-list-tile
                      class="list-restricoes">
                      <v-radio-group
                        v-model="tipo"
                        v-bind="binding"
                        row
                        class="purple-input"
                      >

                        <v-flex>
                          <v-radio
                            :label="strings[idioma].pecuarista"
                            :value="0"/>
                        </v-flex>
                        <v-flex>
                          <v-radio
                            :label="strings[idioma].premium"
                            :value="1"/>
                        </v-flex>
                        <v-flex>
                          <v-radio
                            :label="strings[idioma].consultor"
                            :value="2"/>
                        </v-flex>
                      </v-radio-group>
                    </v-list-tile>
                    <v-list-tile
                      class="list-restricoes">
                      <v-text-field
                        v-model="dataFim"
                        :label="strings[idioma].data_final"
                        type="date"/>
                    </v-list-tile>
                    <v-list-tile
                      class="list-restricoes">
                      <v-text-field
                        v-model="valorPlano"
                        :label="strings[idioma].valor_plano"
                        pattern="\d*"
                        inputmode="decimal"
                        type="float"/>
                    </v-list-tile>
                    <v-list-tile
                      v-if="tipo === 2"
                      class="list-restricoes">
                      <v-text-field
                        v-model="maxClientes"
                        :label="'Máximo de Clientes'"
                        type="number"/>
                    </v-list-tile>
                  </v-list>
                </v-card>
                <v-card-actions>
                  <v-checkbox
                    v-model="novoPlano"
                    label="Criar Novo Plano"/>
                  <v-spacer/>
                  <v-btn
                    color="success"
                    @click="salvarPremium(userPivot, dataFim)"
                  >
                    <v-icon
                      left
                      dark>mdi-content-save</v-icon>
                    {{ strings[idioma].salvar }}
                  </v-btn>
                  <v-btn
                    :title="strings[idioma].fechar"
                    color="error"
                    @click="dialogPremium = false"
                  >
                    <v-icon
                      dark>mdi-close</v-icon>
                  </v-btn>
                </v-card-actions>
              </template>
            </v-card>
          </v-dialog>

        </v-flex>
        
        <!-- 
          AB#5456 - Resolver no futoro. 
        <FreeMap/>
        <template v-if="exibeRelatoriosGoogle">
          <v-layout justify-center wrap>
            <v-flex md8 xs12>
              <iframe width="800" height="1200" src="https://datastudio.google.com/embed/reporting/ab2088cd-f9bc-498e-bdff-06b7a6fadd5a/page/1M" frameborder="0" style="border:0" allowfullscreen></iframe>
              <iframe width="800" height="650" src="https://datastudio.google.com/embed/reporting/c7efbe8b-711b-4c16-bd3e-32421faeaa07/page/MH70C" frameborder="0" style="border:0" allowfullscreen></iframe>          </v-flex>
          </v-layout>
        </template> -->
      </v-card>
      
      <!-- 
        AB#5456 - Resolver no futoro. 
        <Charts/> -->

    </v-layout>

  </v-container>

</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import ChartCard from '../../components/material/ChartCard.vue'
import Charts from './components/Charts.vue'
import FreeMap from './FreeMap.vue'
import {
  replaceSpecialChars
} from '@/utils/vuex'
import { createMD5, exportCSV } from '@/utils/utils'

export default {
  components: {
    ChartCard,
    Charts,
    FreeMap
  },
  data () {
    return {
      tabsEnum: ['usuarios', 'empresas', 'alimentos'],
      tab: null,
      logo: 'img/brcorte-logo.png',
      users: [],
      empresas: [],
      searchUsers: null,
      searchEmpresas: null,
      searchAlimentos: null,
      gerenciaPremium: false,
      alimentos: null,
      alimento: null,
      dialogPremium: false,
      dialogConsultor: false,
      dialogNutrientes: false,
      vincular: false,
      dataFim: null,
      tipo: 1,
      valorPlano: null,
      novoPlano: true,
      userPivot: null,
      premium: false,
      tempo_premium: false,
      loading: false,
      limit: 7,
      pagina: 1,
      paginaTotal: 1,
      filtrarVinculados: false,
      filtrarConsultoria: false,
      filtrarPecuarista: false,
      filtrarPremium: false,
      filtrarPremiumTeste: false,
      filtrarPremiumVencido: false,
      filtrarPlanoVencendo: false,
      filtrarAdmin: false,
      filtrarInativos: false,
      gerenciaConsultor: false,
      consultor: false,
      tempo_consultor: false,
      maxClientes: 10,
      countResultados: 0,
      dataADM: {},
      modoSuperUsuario: false,
      loadingUsers: false
    }
  },
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'dietas', 'predicoes', 'tabelas', 'exibeRelatoriosGoogle']),
    dailySalesChart () {
      return {
        data: {
          labels: Object.keys(this.dataADM.dietasPorDias),
          series: Object.values(this.dataADM.dietasPorDias)
        },
        options: {

          low: 0,
          high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      }
    },
    dataChart () {
      if (!this.dataADM || !this.dataADM.dietasPorDias || this.dataADM === null || this.dataADM.dietasPorDias === null) return { labels: [], series: [] }
      let dietasPorDias = {}
      Object.keys(this.dataADM.dietasPorDias).slice(0, 15).map(a => { ; dietasPorDias[a] = this.dataADM.dietasPorDias[a] })
      console.log({ labels: Object.keys(dietasPorDias), series: [Object.values(dietasPorDias)] })
      return { labels: Object.keys(dietasPorDias).reverse(), series: [Object.values(dietasPorDias).reverse()] }
    },
    dataUserChart () {
      if (!this.dataADM || !this.dataADM.userPorDias || this.dataADM === null || this.dataADM.userPorDias === null) return { labels: [], series: [] }
      let dietasPorDias = {}
      Object.keys(this.dataADM.userPorDias).slice(0, 15).map(a => { ; dietasPorDias[a] = this.dataADM.userPorDias[a] })
      console.log({ labels: Object.keys(dietasPorDias), series: [Object.values(dietasPorDias)] })
      return { labels: Object.keys(dietasPorDias).reverse(), series: [Object.values(dietasPorDias).reverse()] }
    },
    binding () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndUp) binding.row = true
      else binding.row = false
      return binding
    },
    filter () {
      return (item, search, textKey) => item[textKey].toLowerCase().search(search.toLowerCase()) > -1
    },
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 289) + 'px'
    },
    heightDialog () {
      return this.$vuetify.breakpoint.xs ? String(this.$vuetify.breakpoint.height - 150) + 'px' : String(this.$vuetify.breakpoint.height - 240) + 'px'
    },
    heightOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 50) + 'px; overflow: auto;'
    },
    heightTree () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 200) + 'px; overflow: auto; min-height: 200px;'
    },
    usersFilter () {
      if (this.searchUsers === null || this.searchUsers.trim() === '') return this.users
      return this.users.filter(u => {
        const reg = new RegExp(replaceSpecialChars(this.searchUsers.toLowerCase()), 'i')
        return reg.test(u.NOME) || reg.test(u.email) || u.id === parseInt(this.searchUsers) || '#' + u.id === this.searchUsers
      })
    },
    empresasFilter () {
      if (this.searchEmpresas === null || this.searchEmpresas.trim() === '') return this.empresas
      return this.empresas.filter(u => new RegExp(replaceSpecialChars(this.searchEmpresas.toLowerCase()), 'i').test(u.nome) || u.id === parseInt(this.searchEmpresas) || '#' + u.id === this.searchEmpresas)
    },
    alimentosFilter () {
      if (this.searchAlimentos === null || this.searchAlimentos.trim() === '') return (this.alimentos === null) ? [] : this.alimentos
      return (this.alimentos === null) ? [] : this.alimentos.filter(u => new RegExp(replaceSpecialChars(this.searchAlimentos.toLowerCase()), 'i').test(u.nome) || u.id === parseInt(this.searchAlimentos) || '#' + u.id === this.searchAlimentos)
    }
  },
  watch: {
    searchUsers (val) {
      this.recarregaUsers(val)
    },
    pagina (val) {
      this.recarregaUsers(val)
    },
    dataFim (val) {
      console.log(val)
    },
    userPivot (val) {
      // eslint-disable-next-line no-useless-return
      this.novoPlano = true
      this.maxClientes = 10
      this.dataFim = moment().format('YYYY-MM-DD')
      if (val === null) return
      if (this.consultor && val.consultoria !== null && val.consultoria && val.consultoria !== null) {
        this.dataFim = moment(val.consultoria.data_fim).format('YYYY-MM-DD')
        this.maxClientes = val.consultoria.max_clientes
        this.novoPlano = false
        this.tipo = 2
      } else if (val.plano && val.plano !== null) {
        this.dataFim = moment(val.plano.data_final).format('YYYY-MM-DD')
        this.tipo = val.plano.tipo
        this.valorPlano = val.plano.valor
        this.novoPlano = false
        if (this.tipo === 2 && val.consultoria !== null && val.consultoria && val.consultoria !== null) {
          this.maxClientes = val.consultoria.max_clientes
        }
      }
    }
  },
  created () {
    // this.$store.commit('setDietasServer', this.user.data)
    this.$store.commit('getDietas')
    this.$store.commit('getPredicoes')
    this.$store.commit('getTabelasSalvas')
    this.pagina = 1
    this.loadingUsers = true
    this.axios.post('users/get', { limit: this.limit, offset: this.limit * this.pagina, vinculado: this.filtrarVinculados, premium: this.filtrarPremium, premiumTeste: this.filtrarPremiumTeste, consultor: this.filtrarConsultoria, pecuarista: this.filtrarPecuarista, planoVencendo: this.filtrarPlanoVencendo }).then(r => {
      this.countResultados = (r.data.data.len > 1) ? r.data.data.len : r.data.data.users.length
      this.users = r.data.data.users
      this.paginaTotal = r.data.data.paginas
      this.queryWork()
    }).catch(() => {
      this.$router.push('/')
    }).finally(() => {
      this.loadingUsers = false
    })
    this.axios.post('empresa/getEmpresas', {}).then(r => { this.empresas = r.data.data.empresas }).catch(() => this.$router.push('/'))
    this.axios.post('alimentos/getAlimentos', {}).then(r => { this.alimentos = r.data.data }).catch((err) => console.log(err))
    if (!this.categorias_alimentos) {
      this.loadAlimentosDieta()
    }
    this.queryWork()
  },
  methods: {
    gerarUsuariosProximosAVencer () {
      return this.axios.post('relatorios/adm/proximosAVencer').then(r => {
        let dados = r.data.data
        exportCSV(dados)
      })
    },
    gerarComumMenosUsam () {
      return this.axios.post('relatorios/adm/comumMenosUsam').then(r => {
        let dados = r.data.data
        exportCSV(dados)
      })
    },
    gerarComumMaisUsam () {
      return this.axios.post('relatorios/adm/comumMaisUsam').then(r => {
        let dados = r.data.data
        exportCSV(dados)
      })
    },
    gerarPremiumMaisUsam () {
      return this.axios.post('relatorios/adm/premiumMaisUsam').then(r => {
        let dados = r.data.data
        exportCSV(dados)
      })
    },
    gerarPremiumMenosUsam () {
      return this.axios.post('relatorios/adm/premiumMenosUsam').then(r => {
        let dados = r.data.data
        exportCSV(dados)
      })
    },
    gerarVencidos () {
      return this.axios.post('relatorios/adm/vencidos').then(r => {
        let dados = r.data.data
        exportCSV(dados)
      })
    },
    gerarFaturasRenovacao () {
      
      return this.axios.post('jobs/gerarFaturasRenovacao').then(r => {
        alert('Tarefa realizada!')
      })
    },
    gerarPromocao10Renovacao () {
      return this.axios.post('jobs/gerarPromocao10Renovacao').then(r => {
        alert('Tarefa realizada!')
      })
    },
    recarregaAlimentos (val = null) {
      return this.axios.post('alimentos/getAlimentos', {}).then(r => { this.alimentos = r.data.data }).catch((err) => console.log(err))
    },
    recarregaEmpresas (val = null) {
      this.axios.post('empresa/getEmpresas', {}).then(r => { this.empresas = r.data.data.empresas }).catch(() => this.$router.push('/'))
    },
    recarregaUsers (val = null) {
      this.loadingUsers = true
      this.axios.post('users/get', { limit: this.limit, offset: this.limit * this.pagina, vinculado: this.filtrarVinculados, premium: this.filtrarPremium, premiumVencido: this.filtrarPremiumVencido, consultor: this.filtrarConsultoria, pecuarista: this.filtrarPecuarista, adm: this.filtrarAdmin, premiumTeste: this.filtrarPremiumTeste, inativo: this.filtrarInativos, planoVencendo: this.filtrarPlanoVencendo, search: this.searchUsers }).then(r => {
        this.countResultados = (r.data.data.len > 1) ? r.data.data.len : r.data.data.users.length
        this.users = r.data.data.users
        this.paginaTotal = r.data.data.paginas
        this.queryWork()
      }).catch(() => {
        this.$router.push('/')
      }).finally(() => {
        this.loadingUsers = false
      })
    },
    exportaUsers() {
      this.loadingUsers = true
      this.axios.post('users/getUsersSimple', { limit: -1, vinculado: this.filtrarVinculados, premium: this.filtrarPremium, premiumVencido: this.filtrarPremiumVencido, consultor: this.filtrarConsultoria, pecuarista: this.filtrarPecuarista, adm: this.filtrarAdmin, premiumTeste: this.filtrarPremiumTeste, inativo: this.filtrarInativos, planoVencendo: this.filtrarPlanoVencendo, search: this.searchUsers, format: 'csv' }).then(r => {
        exportCSV(r.data.data)
      }).finally(() => {
        this.loadingUsers = false
      })
    },
    queryWork () {
      if (this.$route.query.tab && this.$route.query.tab === 'alimentos') {
        this.tab = 2
      }
      if (this.$route.query.tab && this.$route.query.tab === 'users') {
        this.tab = 0
        if (this.$route.query.ids) {
          let ids = this.$route.query.ids.split(',')
          ids = ids.map(id => parseInt(id))
          this.users.forEach((element, index) => {
            if (ids.includes(element.id)) {
              console.log(this.users[index])
              this.users[index].lido = 0
            }
          })
        }
      }
    },
    moment (...args) {
      return moment(...args)
    },
    parseString (num, idioma) {
      return this.$parseString(num, idioma)
    },
    verAlimento (al) {
      let alimento = Object.assign({}, al)
      alimento.nutrientes = JSON.parse(alimento.nutrientes)
      alimento.tipo = alimento.id_tipo
      for (let nut in alimento.nutrientes) {
        alimento.nutrientes[nut] = parseFloat(alimento.nutrientes[nut]).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
      }
      this.alimento = alimento
      this.dialogNutrientes = true
    },
    removeAlimento (al) {
      delete this.excluir
      if (!this.modoSuperUsuario) return
      let assinatura = createMD5(String(al.id))
      return this.$confirm(this.$store.state, this.strings[this.idioma].msg_remove_confirm).then((r) => {
        if (r !== 'sim') return null
        this.axios.post('alimentos/removeAlimentoSuperUsuario', { ...al, assinatura }).then(r => {
          this.recarregaAlimentos()
          this.modoSuperUsuario = false
        }).catch(() => alert('Não foi possivel excluir o alimento'))
      })
    },
    patrocinar (al, status) {
      this.reprovarPatrocinio = false
      this.aprovarPatrocinio = false
      delete this.reprovarPatrocinio
      delete this.aprovarPatrocinio
      if (status === 1 || confirm(this.strings[this.idioma].msg_confirma_revogacao_patrocinado)) {
        this.axios.post('alimentos/patrocinarAlimento', { id: al.id, patrocinado: status }).then((res) => {
          alert((status === 1) ? this.strings[this.idioma].alimento_patrocinado : this.strings[this.idioma].alimento_patrocinado_revogado)
          al.patrocinado = status
        })
      }
    },
    loadAlimentosDieta () {
      this.loadingAlimentos = true
      this.loadingStep1 = true

      this.axios.post('alimentos/lastUpdateAt', {}).then(response => {
        let lastUpdate = parseInt(response.data.data[1])

        if (lastUpdate === parseInt(localStorage.getItem('lastUpdate'))) {
          if (this.categorias_alimentos) {
            this.loadingStep1 = this.loadingAlimentos = false
            return
          }
          let tipos = JSON.parse(localStorage.getItem('tipos'))
          let alimentos = JSON.parse(localStorage.getItem('alimentos'))
          this.$store.commit('setAlimentos', {
            tipos: tipos,
            alimentos: alimentos
          })
          this.loadingAlimentos = false
          this.loadingStep1 = false
        } else {
          this.axios.post('tipos', {}).then(response => {
            let tipos = response.data.data
            localStorage.setItem('tipos', JSON.stringify(tipos))
            this.axios.post('relatorio/alimentosBrCorte', {}).then(response => {
              localStorage.setItem('alimentos', JSON.stringify(response.data.data))
              this.$store.commit('setAlimentos', {
                tipos: tipos,
                alimentos: response.data.data
              })
              this.loadingAlimentos = false
              this.loadingStep1 = false
              localStorage.setItem('lastUpdate', lastUpdate)
            }).catch(error => {
              console.log(error)
            })
          })
        }
      }).catch(reason => {
        console.log(reason)
      })
    },
    salvarPremium (user, dataFim) {
      this.loading = true
      let valor = this.valorPlano !== null ? String(this.valorPlano).replace(',', '.') : null
      if (moment().diff(dataFim) > 0) {
        let res = confirm(this.strings[this.idioma].msg_data_fim_premium_menor_atual)
        if (!res) {
          this.loading = false
          return
        }
      }
      if (this.userPivot && this.userPivot.consultoria !== null && this.tipo !== 2) {
        this.desativarConsultoria(user)
      }
      this.axios.post('users/setPremium', { id: user.id, premium: 1, data_final: dataFim, tipo: this.tipo, valor: valor, max_clientes: this.maxClientes, novo_plano: this.novoPlano }).then((res) => {
        if (this.tipo === 2) return this.salvarConsultor(user, dataFim)
        this.axios.post('users/get', { limit: this.limit, offset: this.limit * this.pagina }).then(r => { this.users = r.data.data.users; this.dialogPremium = false; this.dialogConsultor = false }).catch(() => window.location.href = '/adm').then(() => { this.loading = false })
      }).catch(() => {
        alert(this.strings[this.idioma].aviso_erro_premium)
        this.loading = false
      })
    },
    salvarConsultor (user, dataFim) {
      this.loading = true
      this.axios.post('consultoria/create', { id_pessoa: user.id, max_clientes: this.maxClientes, data_fim: dataFim, autorizado: true, id: user.consultoria ? user.consultoria.id : null }).then((res) => {
        this.axios.post('users/get', { limit: this.limit, offset: this.limit * this.pagina }).then(r => { this.users = r.data.data.users; this.dialogPremium = false; this.dialogConsultor = false }).catch(() => window.location.href = '/adm').then(() => { this.loading = false })
      }).catch(() => {
        alert(this.strings[this.idioma].aviso_erro_premium)
        this.loading = false
      })
    },
    touglePremium (us) {
      if (this.tempo_premium && this.tempo_premium === true) {
        this.dialogPremium = true
        delete this.premium
        delete this.tempo_premium
        return
      }
      /* this.dialogPremium = true
      delete this.premium */
      let user = Object.assign({}, us)
      user.premium = !user.premium
      if (user && user.consultoria !== null && !user.premium) {
        this.desativarConsultoria(user)
      }
      this.axios.post('users/setPremium', { id: user.id, premium: user.premium }).then((res) => {
        this.axios.post('users/get', { limit: this.limit, offset: this.limit * this.pagina }).then(r => { this.users = r.data.data.users; this.dialogPremium = false }).catch(() => window.location.href = '/adm')
      }).catch(() => {
        alert(this.strings[this.idioma].aviso_erro_premium)
        user.premium = !user.premium
      })
    },
    desativarConsultoria (user) {
      this.axios.post('consultoria/delete', { id: user.consultoria ? user.consultoria.id : null }).then((res) => {
        this.axios.post('users/get', { limit: this.limit, offset: this.limit * this.pagina }).then(r => { this.users = r.data.data.users; this.dialogConsultor = false }).catch(() => window.location.href = '/adm')
      }).catch(() => {
        alert(this.strings[this.idioma].aviso_erro_premium)
      })
    },
    tougleConsultor (us) {
      if (this.tempo_consultor && this.tempo_consultor === true) {
        this.dialogConsultor = true
        delete this.consultoria
        delete this.tempo_consultor
        return
      }
      if (this.consultoria) {
        this.axios.post('consultoria/delete', { id: us.consultoria ? us.consultoria.id : null }).then((res) => {
          this.axios.post('users/get', { limit: this.limit, offset: this.limit * this.pagina }).then(r => { this.users = r.data.data.users; this.dialogConsultor = false }).catch(() => window.location.href = '/adm')
        }).catch(() => {
          alert(this.strings[this.idioma].aviso_erro_premium)
        })
        return
      }
      /* this.dialogPremium = true
      delete this.premium */
      let user = Object.assign({}, us)
      user.premium = !user.premium
      this.axios.post('users/setPremium', { id: user.id, premium: user.premium }).then((res) => {
        this.axios.post('users/get', { limit: this.limit, offset: this.limit * this.pagina }).then(r => { this.users = r.data.data.users; this.dialogPremium = false }).catch(() => window.location.href = '/adm')
      }).catch(() => {
        alert(this.strings[this.idioma].aviso_erro_premium)
        user.premium = !user.premium
      })
    },
    removeEmpresa (empresa) {
      delete this.excluir
      if (!this.modoSuperUsuario) return
      let assinatura = createMD5(String(empresa.id))
      return this.$confirm(this.$store.state, this.strings[this.idioma].msg_remove_confirm).then((r) => {
        if (r !== 'sim') return null
        return this.axios.post('empresa/delete', { id: empresa.id, assinatura }).then(r => {
          this.recarregaEmpresas()
          this.modoSuperUsuario = false
        }).catch(r => {
          alert('Não foi possivel excluir a empresa')
        })
      })
    },
    removeUser (user) {
      delete this.excluir
      if (!this.modoSuperUsuario) return
      let assinatura = createMD5(String(user.id))
      return this.$confirm(this.$store.state, this.strings[this.idioma].msg_remove_confirm).then((r) => {
        if (r !== 'sim') return null
        return this.axios.post('users/delete', { id: user.id, assinatura }).then(r => {
          this.recarregaUsers()
          this.modoSuperUsuario = false
        }).catch(r => {
          alert('Não foi possivel excluir o usuario')
        })
      })
    },
    vincularColaborador (user) {
      delete this.vincular
      sessionStorage.removeItem('empUser')
      sessionStorage.removeItem('userLoad')
      sessionStorage.setItem('userLoad', JSON.stringify(user))
      if (user.emp_user !== null) sessionStorage.setItem('empUser', JSON.stringify(user.emp_user))
      setTimeout(() => {
        window.location.href = '/adm/vincular-colaborador'
      }, 300)
    },
    editUser (user) {
      sessionStorage.setItem('userLoad', JSON.stringify(user))
      setTimeout(() => {
        let tela = window.open('/adm/user/edit', '_blank')
        if (!tela) window.location.href = '/adm/user/edit'
      }, 300)
    },
    editEmpresa (empresa) {
      sessionStorage.setItem('empresaLoad', JSON.stringify(empresa))
      setTimeout(() => {
        window.location.href = '/adm/empresa/edit'
      }, 300)
    }
  }
}
</script>
